import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import "./App.css";
import Home from "./pages/home/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import NewProduct from "./pages/newProduct/NewProduct";
import Onay from "./pages/onay/Onay";
import Ilan from "./pages/advert/Advert";
import IlanList from "./pages/advertList/AdvertList";
import AdvertDetail from "./pages/advertDetail/AdvertDetail";
import InfluencerList from "./pages/influencerList/InfluencerList";
function App() {
  return (
    <Router>
      <Topbar />
      <div className="container">
        <Sidebar />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/users">
            <UserList />
          </Route>
          <Route path="/user/:userId">
            <User />
          </Route>
          <Route path="/newUser">
            <NewUser />
          </Route>
          <Route path="/products">
            <ProductList />
          </Route>
          <Route path="/onay">
            <Onay />
          </Route>
          <Route path="/advert">
            <Ilan />
          </Route>
          <Route path="/advertList">
            <IlanList />
          </Route>
          <Route path="/advertDetail">
            <AdvertDetail />
          </Route>
          <Route path="/influencerList">
            <InfluencerList />
          </Route>
          <Route path="/product/:productId">
            <Product />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
